module.exports = __webpack_public_path__ + "static/MC_steps_nuevos_FISICA_6_B-bfc4c882444ffdbd00c6ff77fcbc1207.gif";